<template>
  <v-container fluid class="px-0">
    <div class="reimbursement-page">
      <v-row>
        <v-col cols="12" md="12">
          <v-card>
            <v-card-text>
              <v-row class="ma-1">
                <v-col cols="12" md="4">
                  <p class="rhead">
                    {{ initvalue.reimbursementtype }} {{ initvalue.reimbursementnum }}
                  </p>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="2" align="right">
                  <v-btn @click="Done" color="primary" text>
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
                </v-btn>
                </v-col>
              </v-row>
              <v-row class="ma-1">
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Num</td>
                        <td>{{ initvalue.reimbursementnum }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Date</td>
                        <td>{{ new Date(initvalue.reimbursementdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Account</td>
                        <td>{{ accounts.find(account=>account._id == initvalue.accountid)['accountname']}}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
                <v-col cols="12" md="4">
<!--                   <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Address</td>
                        <td class="tcell">{{ initvalue.reimbursementaddress }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Phone</td>
                        <td>{{ initvalue.reimbursementphone }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Mobile</td>
                        <td>{{ initvalue.reimbursementphone }}</td>
                      </tr>
                    </table>
                  </p> -->
                </v-col>
                <v-col cols="12" md="4">
<!--                   <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Note</td>
                        <td class="tcell">{{ initvalue.reimbursementnote }}</td>
                      </tr>
                    </table>
                  </p> -->
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1" min-height="282">
                <v-card-text class="pa-5 pt-0">

                  <v-tabs color="secondary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      ref="filesTab"
                      class="text-capitalize font-weight-regular"
                      :key="1"
                      :href="'#tab-items'"
                    >
                      Items
                    </v-tab>
                    <v-tab
                      ref="filesTab"
                      class="text-capitalize font-weight-regular"
                      :key="2"
                      :href="'#tab-files'"
                    >
                      Files
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="3"
                      :href="'#tab-images'"
                    >
                      Images
                    </v-tab>
                    <v-tab-item
                      :key="1"
                      :value="'tab-items'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            loading-text="Loading... Please wait"
                            item-key="_id"
                            :footer-props="footer"
                            :headers="headers"
                            :items="transactions"
                            :items-per-page="itemPerPage">
                            <template v-slot:item.accountid="{ item }">
                              <p class="two-line">{{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}</p>
                            </template>
                            <template v-slot:item.transmount="{ item }">
                              <p class="two-line">{{ item.transamount.toFixed(2) }}</p>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="2"
                      :value="'tab-files'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            :headers="fileHeaders"
                            :items="files"
                            :items-per-page="100"
                            class="elevation-0"
                          >
                            <template v-slot:item.filetype="{ item }">
                              <a
                                v-if="item.filetype == 'pdf'"
                                :href="item.fileurl"
                                style="text-decoration: none !important"
                              >
                                <v-icon size="50" color="primary">
                                  mdi-file-pdf-box
                                </v-icon></a
                              >
                            </template>
                            <template v-slot:item.filesize="{ item }">
                              {{ (item.filesize / 1000).toFixed(0) + " KB" }}
                            </template>
                            <template v-slot:item.createdAt="{ item }">
                              {{
                                new Date(item.createdAt).toLocaleString(
                                  "en-SG",
                                  {
                                    year: "numeric",
                                    month: "numeric",
                                    day: "numeric",
                                  }
                                )
                              }}
                            </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="previewFile(item)"
                          >
                            <v-icon>mdi-text-box-search</v-icon>
                          </v-btn>
                        </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row> </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import config from "@/config";
import { mapState, mapActions } from 'vuex'

export default {
  name: "Profile",

  data() {
    return {
      config,
      initvalue: {},
      transactions: [],
      files: [],
      selectedTab: "1",
      headers: [
        { text: 'Claim', value: 'claimnum' },
        { text: 'Type', value: 'transtype' },
        { text: 'Name', value: 'transname' },
        { text: 'Amount', value: 'transamount' },
      ],
      fileHeaders: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
    };
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Employee', ['employees']),
  },
  methods: {
    ...mapActions('Account', ["getAccountsRequest"]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    ...mapActions("File", ["getReimbursementFiles"]),
    previewFile(item){
      let params = Object.assign({}, this.initvalue);
      params.fileurl = item.fileurl;
      params.isFromReimbursement = true;
      this.$router.push({ name: "FilePreview", params: params })
    },
    Done(){
      if(this.initvalue.isFromAdm==true) this.$router.push({ name: 'ReimbursementList' });
      else if(this.initvalue.isFromHrm==true) this.$router.push({ name: 'ReimbursementList' });
      else this.$router.push({ name: 'ReimbursementList' });
    },
  },
  async created() {
    this.initvalue = this.$route.params;    
    if (!this.initvalue._id) this.$router.push({ name: "ReimbursementList" });
    this.transactions = this.initvalue.transactions;
    this.transactions.sort((a, b) => a.claimnum - b.claimnum)
    this.files = this.initvalue.files;
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.employees.length==0) await this.getEmployeesRequest();
    if(this.initvalue.isFromFiles==true) {this.$refs.filesTab.$el.click()}
  },
};
</script>

<style src="./View.scss" lang="scss"/>
